import React, { useState, useEffect, useRef, useContext } from 'react'
import moment from 'moment'
import { useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { Box, Button, Card, Container, Grid, Typography, CardContent } from '@material-ui/core'
import Loader from '../components/utils/Loader'
import Download from '@material-ui/icons/Download'
import { ShoppingCartContext } from '../contexts/ShoppingCart'
import SearchResult from '../components/SearchResult'

// API
import { getPublicAPI, putPublicAPI } from '../api/index'
import { ToastContext } from '../contexts/Toast'
import logo from '../assets/images/logo.jpg'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import TextField from '@material-ui/core/TextField'
import socket from '../components/Socket'
import {
  
   Menu,
   MenuItem,
   
} from '@material-ui/core'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'

const Orders = () => {
   let mounted = useRef(true)
   const navigate = useNavigate()
   const { setToasts } = useContext(ToastContext)
   const [loading, setLoading] = useState(true)
   const [shipped, setShipped] = useState(null)
   const [orders, setOrders] = useState([])
   const [selectedProduct, setSelectedProduct] = useState(null)
   const [selectedOrder, setSelectedOrder] = useState(null)
   const [postalcompany, setPostalCompany] = useState('')
   const [docketnumber, setDocketNumber] = useState('')
   const [open, setOpen] = useState(false)
   const [sortBy, setSortBy] = useState('Newest')
   const [anchorSortChange, setAnchorSortChange] = useState(null)
   const [sortChange, setSortChange] = useState(false)

   const { innerWidth: windowWidth } = window

   const handleSortChange = event => {
      mounted.current && setSortChange(true)
      mounted.current && setAnchorSortChange(event.currentTarget)
   }

   const handleSortChangeClose = () => mounted.current && setSortChange(false)

   const handlePrice = () => {
      console.log(orders)
      const test = orders
      const getValue = ({ totalAmount }) => +totalAmount || 0
      test.sort((a, b) => getValue(a) - getValue(b))
      //setData({ ...data, ...test })
      setOrders(test)
   }

   const handlePriceHighToLow = () => {
      const test = orders
      const getValue = ({ totalAmount }) => +totalAmount || 0
      test.sort((a, b) => getValue(b) - getValue(a))
      setOrders(test)
   }

   const handleNewest = () => {
      const test = orders
      // test.sort(
      //    (objA, objB) => Number(new Date(objA.updatedAt())) - Number(new Date(objB.updatedAt()))
      // )
      test.sort((a, b) => -a.datetime.localeCompare(b.datetime))
      //console.log(test)
      setOrders(test)
      
   }
   const {
      searchC,
   } = useContext(ShoppingCartContext)

   const handleClickOpen = (product, order) => {
      setPostalCompany('')
      setDocketNumber('')
      setSelectedProduct(product)
      setSelectedOrder(order)
      setOpen(true)
   }

   const handleClose = () => {
      setOpen(false)
   }

   useEffect(() => {
      if (!localStorage.auth_token) navigate('/login')
      return () => (mounted.current = false)
   }, [navigate])

   useEffect(() => {
      const prepareOrders = async () => {
         let data = { user: localStorage.user_email, type: localStorage.user_type }
         let orders = await getPublicAPI('/get-orders', data)

         if (orders?.success) {
            orders.data.sort(
               (a, b) => new Date(b.datetime).getTime() - new Date(a.datetime).getTime()
            )

            mounted.current && setOrders(orders.data)

            if (orders.data?.length > 0)
               setToasts({
                  type: 'info',
                  messages: [{ msg: `Your orders are ready` }]
               })
         } else
            setToasts({
               type: 'error',
               messages: orders?.errors
            })

         setLoading(false)
      }

      prepareOrders()

      return () => (mounted.current = false)
   }, [setToasts])

   const shipProduct = async (order, product) => {
      try {
         if (postalcompany === '') {
            setToasts({
               type: 'error',
               messages: [{ msg: `Enter postal company` }]
            })
         } else if (docketnumber === '') {
            setToasts({
               type: 'error',
               messages: [{ msg: `Enter tracking number` }]
            })
         } else {
            setOpen(false)

            const obj = {}
            obj.user = order.user
            obj.oNum = order.oNum
            obj.product = product.pId

            socket.emit('userNotify', JSON.stringify(obj))
            setShipped(product.pId + order.oNum)

            let params = {
               user: order.user,
               order: order.oNum,
               product: product.pId,
               postalcompany,
               docketnumber
               // single: true
            }

            let shipped = await putPublicAPI('/ship-product', params)
            if (shipped?.success) {
               setToasts({
                  type: 'success',
                  messages: [
                     {
                        // msg: `Product ${product.pId} of User ${order.user} from Order # ${order.oNum} has been shipped`
                        msg: `Product marked as shipped`
                     }
                  ]
               })

               shipped.data.sort(
                  (a, b) => new Date(b.datetime).getTime() - new Date(a.datetime).getTime()
               )

               mounted.current && setOrders(shipped.data)
            } else
               setToasts({
                  type: 'error',
                  messages: shipped?.errors
               })
         }
      } catch (err) {
         setToasts({
            type: 'error',
            messages: [{ msg: err.message }]
         })
      } finally {
         setShipped(null)
         setSelectedProduct(null)
         setSelectedOrder(null)
         // navigate('/app/order-detail/' + order.oNum)
      }
   }

   const downloadOrder = async order => {
      // let signedUrl = await getPublicAPI('/generate-signed-url', { url: order.eFile })

      // if (signedUrl?.success) {
      let downloadLink = document.createElement('a')
      downloadLink.href = order.eFile
      downloadLink.download = order.oNum + '.xlsx'
      downloadLink.click()
      // }
   }

   socket.on('notifyAdmin', msg => {
      const prepareOrders = async () => {
         let data = { user: localStorage.user_email, type: localStorage.user_type }
         let orders = await getPublicAPI('/get-orders', data)

         if (orders?.success) {
            orders.data.sort(
               (a, b) => new Date(b.datetime).getTime() - new Date(a.datetime).getTime()
            )

            mounted.current && setOrders(orders.data)
         }
      }

      prepareOrders()
   })

   return (
      <>
         <Helmet>
            <title>{loading ? 'Loading...' : 'Orders | The HosePod'}</title>
         </Helmet>
         <Box
            sx={{
               backgroundColor: 'background.default',
               minHeight: '100%',
               py: 3
            }}
         >
            <Container maxWidth={false}>
               {loading ? (
                  <Loader />
               ) : searchC ? (
                  <SearchResult />
               ) : (
                  <>
                     <Grid sx={{ p: 5, flexDirection: 'column' }} container spacing={3}>
                        <Box>
                           <Typography color='textPrimary' gutterBottom className='part-number'>
                              {localStorage.user_type !== 'customer'
                                 ? 'Received orders'
                                 : 'My Orders'}
                           </Typography>
                        </Box>
                        <Card sx={{ backgroundColor: '#fff', boxShadow: 0 }}>
                           {orders.length > 0 ? (
                              // <PerfectScrollbar>
                              <>
                                 <Box
                                    sx={{
                                       display: 'flex',
                                       flexDirection: windowWidth < 450 ? 'column' : 'row',
                                       justifyContent: 'space-between',
                                       alignItems: 'center',
                                       pt: 3
                                    }}
                                 >
                                    <Box></Box>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                       <Typography variant='h5'>Sort: </Typography>
                                       <Button
                                          sx={{ width: 200, ml: 2 }}
                                          variant='outlined'
                                          endIcon={<ArrowDropDownIcon />}
                                          style={{}}
                                          aria-owns={sortChange ? 'sort-change' : null}
                                          aria-haspopup='true'
                                          onClick={handleSortChange}
                                          // onMouseOver={handleNumberChange}
                                       >
                                          {sortBy}
                                       </Button>
                                       <Menu
                                          sx={{ top: -20 }}
                                          id='sort-change'
                                          className='nav-menu'
                                          anchorEl={anchorSortChange}
                                          open={sortChange}
                                          onClose={handleSortChangeClose}
                                          PaperProps={{
                                             style: {
                                                mt: 0,
                                                width: 200
                                             }
                                          }}
                                       >
                                          <MenuItem
                                             onClick={() => {
                                                setSortBy('Newest')
                                                handleNewest()
                                                handleSortChangeClose()
                                             }}
                                          >
                                             Newest
                                          </MenuItem>
                                          <MenuItem
                                             onClick={() => {
                                                setSortBy('Price low to high')
                                                handlePrice()
                                                handleSortChangeClose()
                                             }}
                                          >
                                             Price low to high
                                          </MenuItem>
                                          <MenuItem
                                             onClick={() => {
                                                setSortBy('Price high to low')
                                                handlePriceHighToLow()
                                                handleSortChangeClose()
                                             }}
                                          >
                                             Price high to low
                                          </MenuItem>
                                       </Menu>
                                    </Box>
                                 </Box>
                                 <Box className='whole-orders' sx={{ backgroundColor: '#fff' }}>
                                    {orders?.map((order, index) => (
                                       <Box key={index} className='order-head'>
                                          <Box className='order-inner-head'>
                                             <Box className='order-head-info'>
                                                <Box>
                                                   <Typography sx={{ fontWeight: '600' }}>
                                                      ORDER PLACED
                                                   </Typography>
                                                   <Typography>
                                                      {moment
                                                         .utc(order.datetime)
                                                         .local()
                                                         .format('hh:mm A, DD MMM YYYY')}
                                                   </Typography>
                                                </Box>
                                                <Box>
                                                   <Typography sx={{ fontWeight: '600' }}>
                                                      TOTAL
                                                   </Typography>
                                                   <Typography>{`$${order.totalAmount?.toFixed(
                                                      2
                                                   )}`}</Typography>
                                                </Box>
                                             </Box>
                                             <Box className='download-view' sx={{ mb: 1 }}>
                                                <CardContent
                                                   onClick={() =>
                                                      navigate('/app/order-detail/' + order.oNum)
                                                   }
                                                >
                                                   <Typography
                                                      sx={{ fontWeight: '600' }}
                                                   >{`ORDER # ${order.oNum}`}</Typography>
                                                   <Typography
                                                      sx={{ fontWeight: '600' }}
                                                   >{`PURCHASE # ${order.purNum}`}</Typography>
                                                   {localStorage.user_type !== 'customer' && (
                                                      <Typography
                                                         sx={{ fontWeight: '600' }}
                                                      >{`ORDERED BY: ${order.user}`}</Typography>
                                                   )}
                                                </CardContent>
                                                {order.eFile && (
                                                   <Button
                                                      sx={{ float: 'right' }}
                                                      onClick={() => downloadOrder(order)}
                                                   >
                                                      <Download
                                                         color='textPrimary'
                                                         fontSize='large'
                                                      />
                                                   </Button>
                                                )}
                                             </Box>
                                          </Box>
                                          <Box sx={{ p: 4, background: '#fff', borderRadius: 2 }}>
                                             {order.products?.map((product, index) => {
                                                return (
                                                   <Box key={index} className='order-products'>
                                                      <Box sx={{ pl: 2 }}>
                                                         <img
                                                            className='order-product-images'
                                                            src={
                                                               product.pictures.length > 0
                                                                  ? product.pictures[0]
                                                                  : logo
                                                            }
                                                            alt={product.rhpn}
                                                         />
                                                      </Box>
                                                      <Box sx={{ p: 3 }}>
                                                         <Typography
                                                            sx={{
                                                               fontWeight: '600',
                                                               color: 'grey'
                                                            }}
                                                         >
                                                            {product.rhpn + ' | ' + product.desc}
                                                         </Typography>
                                                         <Typography
                                                            sx={{
                                                               fontWeight: '600',
                                                               color: 'grey'
                                                            }}
                                                         >
                                                            {'Price: $'}
                                                            {product.type === 'hose'
                                                               ? parseFloat(
                                                                    (
                                                                       parseFloat(product.amount) /
                                                                       (parseFloat(
                                                                          product.qty.split('-')[0]
                                                                       ) +
                                                                          parseFloat(
                                                                             product.qty.split(
                                                                                '-'
                                                                             )[1]
                                                                          ) /
                                                                             12)
                                                                    ).toFixed(2)
                                                                 )
                                                               : (
                                                                    parseFloat(product.amount) /
                                                                    parseFloat(product.qty)
                                                                 ).toFixed(2)}
                                                         </Typography>

                                                         <Typography
                                                            sx={{
                                                               fontWeight: '600',
                                                               color: 'grey'
                                                            }}
                                                         >
                                                            {'Quantity: '}
                                                            {product.type === 'hose'
                                                               ? `${product.qty.split('-')[0]} ${
                                                                    parseInt(
                                                                       product.qty.split('-')[0]
                                                                    ) === 1
                                                                       ? `feet`
                                                                       : `feets`
                                                                 } ${product.qty.split('-')[1]} ${
                                                                    parseInt(
                                                                       product.qty.split('-')[1]
                                                                    ) === 1
                                                                       ? `inch`
                                                                       : `inches`
                                                                 }`
                                                               : product.qty}
                                                         </Typography>
                                                         <Typography
                                                            sx={{
                                                               fontWeight: '600',
                                                               color: 'grey'
                                                            }}
                                                         >
                                                            {'Amount: $' + product.amount}
                                                         </Typography>
                                                         {product.postalCompany &&
                                                            product.postalCompany.length > 0 && (
                                                               <Typography
                                                                  sx={{
                                                                     fontWeight: '600',
                                                                     color: 'grey'
                                                                  }}
                                                               >
                                                                  {'Carrier Name: ' +
                                                                     product.postalCompany.toUpperCase()}
                                                               </Typography>
                                                            )}
                                                         {product.docketNumber &&
                                                            product.docketNumber.length > 0 && (
                                                               <Typography
                                                                  sx={{
                                                                     fontWeight: '600',
                                                                     color: 'grey'
                                                                  }}
                                                               >
                                                                  {'Tracking Number: ' +
                                                                     product.docketNumber}
                                                               </Typography>
                                                            )}
                                                      </Box>
                                                      <Box
                                                         sx={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center',
                                                            width: '100%'
                                                         }}
                                                      >
                                                         {product.status === 'processing' ? (
                                                            <Typography
                                                               className='order-status'
                                                               sx={{
                                                                  pl: 3,
                                                                  color: 'greenyellow'
                                                               }}
                                                            >
                                                               Processing
                                                            </Typography>
                                                         ) : (
                                                            <Typography
                                                               className='order-status'
                                                               sx={{
                                                                  pl: 3,
                                                                  color: '#d22f25'
                                                               }}
                                                            >
                                                               Shipped
                                                            </Typography>
                                                         )}
                                                         {localStorage.user_type !== 'customer' &&
                                                            product.status === 'processing' && (
                                                               <>
                                                                  <Button
                                                                     variant='contained'
                                                                     disabled={
                                                                        shipped ===
                                                                        product.pId + order.oNum
                                                                     }
                                                                     sx={{ fontWeight: '600' }}
                                                                     onClick={() =>
                                                                        handleClickOpen(
                                                                           product,
                                                                           order
                                                                        )
                                                                     }
                                                                  >
                                                                     Ship
                                                                  </Button>
                                                                  <Dialog
                                                                     open={open}
                                                                     onClose={handleClose}
                                                                     aria-labelledby='form-dialog-title'
                                                                  >
                                                                     <DialogTitle id='form-dialog-title'>
                                                                        Shipping Particulars
                                                                     </DialogTitle>
                                                                     <DialogContent>
                                                                        <DialogContentText>
                                                                           Enter shipping details
                                                                        </DialogContentText>
                                                                        <TextField
                                                                           autoFocus
                                                                           margin='dense'
                                                                           id='filled-error'
                                                                           label='Postal Company'
                                                                           fullWidth
                                                                           onChange={e => {
                                                                              setPostalCompany(
                                                                                 e.target.value
                                                                              )
                                                                           }}
                                                                        />
                                                                        <TextField
                                                                           autoFocus
                                                                           margin='dense'
                                                                           label='Tracking Number'
                                                                           fullWidth
                                                                           onChange={e => {
                                                                              setDocketNumber(
                                                                                 e.target.value
                                                                              )
                                                                           }}
                                                                        />
                                                                     </DialogContent>
                                                                     <DialogActions>
                                                                        <Button
                                                                           onClick={() =>
                                                                              shipProduct(
                                                                                 selectedOrder,
                                                                                 selectedProduct
                                                                              )
                                                                           }
                                                                           color='secondary'
                                                                        >
                                                                           Ship
                                                                        </Button>
                                                                     </DialogActions>
                                                                  </Dialog>
                                                               </>
                                                            )}
                                                      </Box>
                                                   </Box>
                                                )
                                             })}
                                          </Box>
                                       </Box>
                                    ))}
                                 </Box>
                              </>
                           ) : (
                              // </PerfectScrollbar>
                              <Box sx={{ p: 5 }}>
                                 <Typography
                                    sx={{
                                       fontWeight: '600',
                                       fontSize: '24px',
                                       textAlign: 'center'
                                    }}
                                 >
                                    No orders received.
                                 </Typography>
                              </Box>
                           )}
                        </Card>
                     </Grid>
                  </>
               )}
            </Container>
         </Box>
      </>
   )
}

export default Orders